import { render, staticRenderFns } from "./DefinitionListItem.vue?vue&type=template&id=107315cd&"
import script from "./DefinitionListItem.vue?vue&type=script&lang=ts&"
export * from "./DefinitionListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports